<template>
  <div class="show-answer">
    {{ responses.percentage }} <span class="fa fa-bullhorn answer" />
    {{ remarkCount }} <span class="fa fa-comment-o answer" />
    <div
      class="answers"
      :class="{ 'set-height' : maxHeight }"
    >
      <div
        v-for="(remark, index) in remarks"
        class="bs-callout bs-callout-info"
      >
        <a @click="openModal"> <i
          class="abuse fa fa-eye-slash"
          style="cursor:pointer"
          aria-hidden="true"
          data-toggle="tooltip"
          :title="trans('review.report_abuse')"
        /></a>
        <div class="text">
          {{ remark.remark }}
        </div>

        <modal
          :open="open"
          :title="trans('review.report_abuse')"
          @close="closeModal"
        >
          <p><em>{{ remark.remark }}</em></p>
          <p>{{ trans('review.confirm_abuse') }}</p>
          <div class="pull-right">
            <button
              class="btn btn-default"
              @click="closeModal"
            >
              {{ trans('core.cancel') }}
            </button>
            <button
              class="btn btn-primary"
              @click="deleteRemark(index)"
            >
              {{ trans('core.ok') }}
            </button>
          </div>
          <div style="clear:both" />
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
import toast from '../../../../../services/toast'
import Modal from '../../../../../students/student-calendar/components/Modal'
import { defaultErrorMessage } from '@/helpers'
import axios from 'axios'

export default {
  name: 'OpenQuestionResult',
  components: { Modal },
  props: {
    remarks: { required: true },
    responses: { required: true },
    maxHeight: { default: true },
  },
  data () {
    return { open: false }
  },
  computed: {
    remarkCount () {
      return Object.keys(this.remarks).length
    },
  },
  methods: {

    openModal () {
      this.open = true
    },
    closeModal () {
      this.open = false
    },

    deleteRemark (remarkID) {
      let id = this.remarks[remarkID].id

      axios.delete('/review/remarks/' + id).then(({ data }) => {
        this.remarks.splice(remarkID, 1)
        toast.success(Lang.get('review.reported_abuse'))
        this.open = false
      }).catch(error => defaultErrorMessage(error))
    },
  },
}
</script>

<style scoped>
    .answer {
        margin-right: 20px;
    }

    .show-answer {
        padding-left: 30px;

    }

    .bs-callout {
        text-align: left;
        margin-bottom: 2px;
        padding: 10px;
        border: 1px solid #eee;
        border-left-width: 2px;
        border-radius: 3px;
        border-left-color: #607D8B;
    }

    .answers {
        overflow-y: auto;
        margin-top: 5px;
        margin-bottom: 5px;
    }

    .set-height {
        max-height: 175px;
    }

    .text {
        width: 95%;
        word-break: break-word;
        white-space: normal !important;
    }

    .abuse {
        float: right;
        margin-right: 10px;
    }

</style>
